var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: _vm.modalState.first,
        expression: "modalState.first",
      },
    ],
    attrs: { container: "modal-container" },
    on: {
      close: function ($event) {
        return _vm.updateModal("first", false)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h3", [_vm._v("Your First Scan")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "aria-label": "Close Modal" },
                on: {
                  click: function ($event) {
                    return _vm.updateModal("first", false)
                  },
                },
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "Your Autobahn vulnerability scan has been queued and will start shortly. You will receive an email when your scan is complete. Thank you."
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }